<template>
  <div class="dashboard">
    <div class="--inner">
      <div class="--content">

          <!-- routesMap /-->

      
        <div class="--alcance-month-control">
          <MonthControl 
            :month="_linearMonth"
            @onChange="onChangeMonth" 
            />
        </div>
        <div class="alcance">
          <div class="--filter-linear mb-3" >
            <h2>Reservas</h2>
            <el-select v-model="_linearYear" placeholder="Seleccione un año" class="">
              <el-option
                v-for="year in _years"
                :key="year"
                :label="year"
                :value="year"
              />
            </el-select>
          </div>
          <AreaBasic :data="lineChart" :labels="lineChartLabel" />
        </div>
        <div class="indicators">
          <div>
            <Indicator
              title="Hoy"
              currency=""
              :amount="$currencyFormat(todayIndicator.amount, 'USD')"
              :detail="todayIndicator.detail"
              :growth_value="todayIndicator.growth_value"
              :isGrowth="todayIndicator.growth_value > 0"
            >
              <template #qty>
                <ConvertCurrency :value="todayIndicator.amount" :currency="currency" />
              </template>
            </Indicator>
          </div>
          <div>
            <Indicator
              :title="`Mes de ${currentMonthString}`"
              currency=""
              :amount="$currencyFormat(monthIndicator.amount, 'USD')"
              :detail="monthIndicator.detail"
              :growth_value="monthIndicator.growth_value"
              :isGrowth="monthIndicator.growth_value > 0"
            >
              <template #qty>
                <ConvertCurrency :value="monthIndicator.amount" :currency="currency" />
              </template>
            </Indicator>
          </div>
          <div>
            <Indicator
              :title="`Trimestre/Q${_quarterCurrent}`"
              currency=""
              :amount="$currencyFormat(quarterIndicator.amount, 'USD')"
              :detail="quarterIndicator.detail"
              :growth_value="quarterIndicator.growth_value"
              :isGrowth="quarterIndicator.growth_value > 0"
            >
              <template #qty>
                <ConvertCurrency :value="quarterIndicator.amount" :currency="currency" />
              </template>
            </Indicator>
          </div>
          <div>
            <Indicator
              currency=""
              :title="`Año/${currentYear}`"
              :amount="$currencyFormat(yearIndicator.amount, 'USD')"
              :detail="yearIndicator.detail"
              :growth_value="yearIndicator.growth_value"
              :isGrowth="yearIndicator.growth_value > 0"
            >
              <template #qty>
                <ConvertCurrency :value="yearIndicator.amount" :currency="currency" />
              </template>
            </Indicator>
          </div>
        </div>
        <div class="--voucher">
          <header>
            <div class="--details">
              <div class="--title">
                <div class="--number">10</div>
                <h2>
                  <span>Últimas reservas</span>
                  <span> Estas son tus últimas reservas a la fecha </span>
                </h2>
              </div>
              <div class="--actions">
                <el-button text round  type="primary" @click="$router.push('/booking')">
                  Ver todas las reservas
                  <IconDynamics iconName="IconArrowRight" />
                  <!-- 
                  -->
                </el-button>
              </div>
            </div>
          </header>
          <el-table :data="_vouchers" style="width: 100%">
            <el-table-column prop="voucherNumber" label="Voucher" >
              <template #default="scope">
                <el-button text type="info" @click="$router.push(`/booking/${scope.row._id}/voucher`)">
                  {{ scope.row._id.slice(-6) }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="Fecha">
              <template #default="scope">
                {{ $formateDate(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column prop="payments" label="Total">
              <template #default="scope">
                <template v-if="getPrice(scope.row.payments, currency)">
                  {{ $currencyFormat(getPrice(scope.row.payments, currency), currency) }}
                </template>
                <template v-else>
                  {{ $currencyFormat(scope.row.payments.client, getCurrency(scope.row)) }}
                </template>
              </template>
            </el-table-column>

            <el-table-column prop="status" label="Estado">
              <template #default="scope">
                <el-tag
                  :type="
                    scope.row.status === 'confirmed'
                      ? 'success'
                      : scope.row.status === 'pending'
                      ? 'warning'
                      : 'danger'
                  "
                >
                  {{ statuses?.[scope.row.status] ? statuses[scope.row.status] : scope.row.status }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="--sidebar">
        <div class="--item-sidebar --shortcuts">
          <Card>
            <template #header>
              <h2>Atajos</h2>
              <p>Accesos rápidos a las secciones más importantes</p>
            </template>
            <template #body>
              <el-scrollbar height="300px" class="mt-2 !pr-3">
                <Shortcut
                  v-for="_module in modulesAvailable"
                  :backgroundIconColor="_module.background_color"
                  iconColor="#fff"
                  :url="_module.url"
                >
                  <template #icon>
                    <IconDynamics :iconName="_module.icon" />
                  </template>
                  <template #title>
                    {{ _module.name }}
                  </template>
                  <template #subtitle>
                    {{ _module.company }}
                  </template>
                </Shortcut>
              </el-scrollbar>
            </template>
          </Card>
        </div>
        <div class="--item-sidebar">
          <WeatherCard />
        </div>
        <div class="--item-sidebar">
          <Card>
            <template #header>
              <h2>Estado de las ventas</h2>
              <p>
                Vista rápida de la salud de tus ventas. Entérate de como va tu agencia
              </p>
            </template>
            <template #body>
              <div class="--filter-status mb-3" >
                <span>
                  Filtro
                </span>
                <el-select 
                  v-model="statusMonth" class="" 
                  placeholder="Seleccione un mes"
                  @change="(value)=> changeStatusMonthReport(value)"
                  >
                  <el-option
                    v-for="(month, index) in _months"
                    :key="index + 1"
                    :label="months[index]"
                    :value="index + 1"
                  />
                </el-select>
              </div> 
              <DonutChart class="w-full mt-2" v-model:dataset="statusIndicator" />
            </template>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue"
import { statuses } from "@/lib/booking.js"
import Indicator from "@/components/metrics/indicators.vue"
import AreaBasic from "@/components/metrics/areaBasic.vue"
import DonutChart from "@/components/metrics/donutChart.vue"
import ConvertCurrency from "@/components/currency/convertCurrency.vue"

import routesMap from "@/components/metrics/routesMap.vue"
import Card from "@/components/ui/card.vue"
import Shortcut from "@/components/ui/shortcut.vue"
import MonthControl from "@/components/ui/monthControl.vue"
import WeatherCard from "@/components/ui/WeatherCard.vue"
import IconAirPlain from "@/components/icons/IconAirPlain.vue"
import IconDynamics from "@/components/dashboard/Icon.vue"

import { useUserStore } from "@/stores/user"
const userStore = useUserStore()

import { useCurrencyStore } from "@/stores/currency"
const currencyStore = useCurrencyStore()

import {useAgencyStore} from '@/stores/agency'
const agencyStore = useAgencyStore()

import axios from "@/plugins/axios"
import { ref, onMounted, watch } from "vue"
import { DateTime } from "luxon"
import {getPrice} from '@/utilities/getPrice.js'

const lineChart = ref([])
const lineChartLabel = ref([])
const _vouchers = ref([])
const _months = ref([])
const _years = ref([])
const _quarterCurrent = ref(0)

const currentDate = ref(DateTime.now())
const currentMonth = ref(currentDate.value.month)
const statusMonth = ref(currentDate.value.month)
const currentDay = ref(currentDate.value.day)
const currentYear = ref(currentDate.value.year)
const _linearYear = ref(currentDate.value.year)
const _linearMonth = ref(currentDate.value.month)
const months = ref([
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
]);

const currentMonthString = ref(months.value[currentMonth.value - 1]);

const modulesAvailable = computed(() =>
  userStore.getModules
    .map((item) => {
      if (item?.active)
        return {
          name: item.name,
          company: item.company,
          icon: item.icon,
          background_color: item.background_color,
          url: item.url,
        };
    })
    .filter((item) => item)
);

const statusIndicator = ref({
  pending: 0,
  cancelled: 0,
  approved: 0,
});

const todayIndicator = ref({
  amount: 0,
  detail: "0 Reservas",
  growth_value: 0,
});

const monthIndicator = ref({
  amount: 0,
  detail: "0 Reservas",
  growth_value: 0,
});

const quarterIndicator = ref({
  amount: 0,
  detail: "0 Reservas",
  growth_value: 0,
});

const yearIndicator = ref({
  amount: 0,
  detail: "0 Reservas",
  growth_value: 0,
});

const currency = computed(() => {
  return agencyStore.currency
})


watch(()=> _linearYear.value, (newVal) => {
  calculeLineChart(_linearMonth.value)
})

const getCurrency = (row) => {
  return (row.payments?.currency || row.price?.currency || row?.cancellationPolicyCurrency|| row?.payments?.cancellationPolicyCurrency )?.toLowerCase()
}

const fetchLineChart = async (month, year) => {
  const response = await axios.get(`/api/dashboard/voucher-by-month-chart?month=${month}&year=${_linearYear.value}`);
  return response.data?.data;
};

const fetchIndicatorReport = async (currentYear, currentMonth) => {
  const response = await axios.get(`/api/dashboard/voucher-yearly-report`); 

  return response.data?.data;
};

const fetchStatusReport = async (year, month) => {
  const response = await axios.get(
    `/api/dashboard/voucher-by-status-chart?mockup=false&month=${month}&year=${year}`
  );

  return response.data?.data;
};
const fetchYears = async (year, month) => {
  const response = await axios.get(
    `/api/dashboard/year/available`
  );

  _years.value = response.data?.years;
};

const fetchLastVouchers = async () => {
  const response = await axios.get(`/api/dashboard/last-vouchers?limit=10&mockup=false&year=${currentYear.value}`);

  return response.data?.data;
};
const monthsAvailable  = async () => {
  const response = await axios.get(`/api/dashboard/month/available?year=${currentYear.value}`);

  return response.data?.months;
};

const  initialMonthsAvailable = async () => {

 _months.value = await monthsAvailable()

};
const calculateLineChart = () => {};
const getDaysInMonth = (monthNumber, year) => {
  console.log('monthNumber', monthNumber, year);
  const date = DateTime.local(year, monthNumber);
  const daysInMonth = date.daysInMonth;
  const days = Array(daysInMonth).fill(0)

  return days;
};

const calculeLineChart = async (month) => {
  lineChartLabel.value = [];
  const daysInMonth = getDaysInMonth(month, _linearYear.value);
  const dataSet = await fetchLineChart(month);

  const labels = daysInMonth.map((item, index) => index + 1);

  lineChartLabel.value = labels;

  for (let item of dataSet) {
    console.log('item', item.day);
    daysInMonth[item.day - 1] = item.totalAmountPayed;

    console.log('day, value', item.day, item.totalAmountPayed);
   
  }


  console.log({daysInMonth});

  lineChart.value = daysInMonth;
};

const initialLineChart = async () => {
  calculeLineChart(_linearMonth.value);
};

const onChangeMonth =  (month) => {
  calculeLineChart(month);
};

const initialIndicatorReport = async (currentYear, currentMonth) => {
  const dataSet = await fetchIndicatorReport(currentYear, currentMonth);

  todayIndicator.value.amount = dataSet.today.totalAmount;
  todayIndicator.value.growth_value = dataSet.today.percentageChange;
  todayIndicator.value.detail = `${dataSet.today.count} Reservas`;

  monthIndicator.value.amount = dataSet.month.totalAmount;
  monthIndicator.value.growth_value = dataSet.month.percentageChange;
  monthIndicator.value.detail = `${dataSet.month.count} Reservas`;

  quarterIndicator.value.amount = dataSet.quarter.totalAmount;
  quarterIndicator.value.growth_value = dataSet.quarter.percentageChange;
  quarterIndicator.value.detail = `${dataSet.quarter.count} Reservas`;

  yearIndicator.value.amount = dataSet.year.totalAmount;
  yearIndicator.value.growth_value = dataSet.year.percentageChange;
  yearIndicator.value.detail = `${dataSet.year.count} Reservas`;
};

const getStatusReport = async (year, month) => {

  const dataSet = await fetchStatusReport(year, month);

  const cancelledStatuses = dataSet.find((item) => item._id === "cancelled");
  const pendingStatuses = dataSet.find((item) => item._id === "pending");
  const confirmedStatuses = dataSet.find((item) => item._id === "confirmed");

  statusIndicator.value.pending = pendingStatuses?.count || 0;
  statusIndicator.value.cancelled = cancelledStatuses?.count || 0;
  statusIndicator.value.approved = confirmedStatuses?.count || 0;
};

const initialStatusReport = async () => {
  await getStatusReport(currentYear.value, currentMonth.value);
};

const changeStatusMonthReport = async (month) => {

   await getStatusReport(currentYear.value, month);
   
};

const lastVouchers = async () => {
  _vouchers.value = await fetchLastVouchers();
};

const determineQuarter = (date) => {
  const dt = DateTime.fromJSDate(date);
  const month = dt.month;
  
  if (month <= 3) return 1;
  if (month <= 6) return 2;
  if (month <= 9) return 3;
  return 4;
};

const getCurrentQuarter = () => {
  _quarterCurrent.value =  determineQuarter(new Date());
};

onMounted(() => {
  initialLineChart();
  initialIndicatorReport(currentYear, currentMonth);
  initialMonthsAvailable()
  initialStatusReport();
  lastVouchers();
  getCurrentQuarter();
  fetchYears()
  currencyStore.getCurrencyValues()
 
});
</script>
<style lang="scss">
.dashboard {
  min-height: 100vh;
  display: flex;
  width: 100%;
  max-width: 1280px;
  margin: 12px auto 0;
  flex-direction: column;
  gap: 24px;
  .--inner {
    display: grid;
    grid-template-columns: minmax(760px, 900px) 1fr;
    gap: 24px;
    .--content {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
    .--sidebar {
      display: flex;
      flex-direction: column;
      gap: 24px;
      box-sizing: border-box;
      .--item-sidebar {
        box-sizing: border-box;
        flex-grow: 0;
        box-sizing: border-box;
        &.--shortcuts {
          .--card {
            padding-bottom: 24px;
            .body {
              .--shortcut {
                margin-bottom: 8px;
              }
            }
          }
        }
      }
    }
    .alcance {
      background: #fff;
      padding: 1em 1em 2em;
      border-radius: 12px;
      box-sizing: border-box;
      h2 {
        margin: 0;
      }
    }
    .indicators {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 12px;
      @media (max-width: 1290px) {
        .qty {
          font-size: 18px;
        }
        .footer {
          font-size: 14px;
        }
      }
    }
    .--voucher {
      background: #fff;
      padding: 1em;
      border-radius: 12px;
      .--details {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
        .--title {
          font-size: 18px;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 12px;
          .--number {
            font-size: 48px !important;
            font-weight: 700;
          }
          h2 {
            margin: 0;
            font-size: 24px;
            font-weight: 400;
            span {
              display: block;
              &:first-child {
                font-weight: 800;
              }
              &:last-child {
                font-size: 12px;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
    .--alcance-month-control {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 720px;
      align-self: center;
      padding:1em
    }
    .--filter-linear,
    .--filter-status {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 1em;
      span {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
  @media (min-width: 1360px) {
    max-width: 1390px;
    width: 100%;
    .--inner {
      grid-template-columns: 1fr 360px;
      gap: 24px;
    }
  }
}
@media (min-width: 1024px) {
}
</style>
